module.exports = __webpack_public_path__ + "static/media/klasa_4.51cc8b25.svg";